import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import useReStoreScrollTop from '@/utils/customHooks/useScrollToTop';
import IntelligentDesignPad from '&/pages/landing-page/IntelligentDesignPad';
import Solution from '&/pages/landing-page/solution';
import MarketingDesign from '&/pages/landing-page/marketingDesign';
import Example from './Example';
import LandingPage from './LandingPage';
import IntelligentDesign from './IntelligentDesign';
import businessCooperation from '&/pages/landing-page/businessCooperation';
import aboutFoxitHD from '&/pages/landing-page/aboutFoxitHD';
import Channel from '&/pages/landing-page/channel';
import Combo from '&/pages/landing-page/FamilyBucket';
import AssembledCeiling from '&/pages/landing-page/assembledCeiling';
import PramsEdit from '&/pages/landing-page/paramsEdit';
import TechnicalAuth from '&/pages/landing-page/technicalAuth';
import ElectronicDrawing from '&/pages/landing-page/digitalDrawing';
import MaterialDownload from '&/pages/landing-page/materialDownload';
import './index.scss';
export default function () {
    // 二级路由
    const ROUTES = [
        {
            path: '/landing/index',
            component: LandingPage,
        },
        {
            path: '/landing/example',
            component: Example,
        },
        {
            path: '/landing/IntelligentDesign',
            component: IntelligentDesign,
        },
        {
            path: '/landing/IntelligentDesignPad',
            component: IntelligentDesignPad,
        },
        {
            path: '/landing/aboutFoxitHD',
            component: aboutFoxitHD,
        },
        {
            path: '/landing/businessCooperation',
            component: businessCooperation,
        },
        {
            path: '/landing/merchantWillMoveInto',
            component: businessCooperation,
        },
        {
            path: '/landing/solution',
            component: Solution,
        },
        {
            path: '/landing/marketingDesign',
            component: MarketingDesign,
        },
        {
            path: '/landing/channel',
            component: Channel,
        },
        {
            path: '/landing/combo',
            component: Combo,
        },
        {
            path: '/landing/ceiling',
            component: AssembledCeiling,
        },
        {
            path: '/landing/paramsEdit',
            component: PramsEdit,
        },
        {
            path: '/landing/technicalAuth',
            component: TechnicalAuth,
        },
        {
            path: '/landing/digitalDrawing',
            component: ElectronicDrawing,
        },
        {
            path: '/landing/materialDownload',
            component: MaterialDownload,
        },
    ];
    const [{ path: SUB_HOME }] = ROUTES;
    const { pathname } = useLocation();

    const htmlSuffixTarget = (() => {
        if (!/\/index\.html$/.test(pathname)) return null;
        const stripped = pathname.replace(/\/index\.html$/, '');
        return ROUTES.some(item => item.path === stripped) ? stripped : null;
    })();

    useReStoreScrollTop();

    return (
        <Switch>
            {ROUTES.map((item, idx) => (
                <Route
                    exact
                    key={idx}
                    path={item.path}
                    children={<item.component />}
                />
            ))}
            {htmlSuffixTarget && <Redirect to={htmlSuffixTarget} />}
            <Redirect to={SUB_HOME} />
        </Switch>
    );
}
